
	import Farmer from '@/component/farmer/farmer.vue'
	import { loadInstanceTranslations, i18n } from '@/model/i18n'
	const messages = {
	"add_website": "Add a website",
	"add_github": "Add a GitHub",
	"add_title": "Add a title",
	"admin": "Administrator",
	"already_in_team": "You are already a member of a team",
	"already_registered": "You are already registered for this tournament",
	"banned": "Farmer banned",
	"banned_message": "This farmer has been banned",
	"bonus_trophies": "Bonus trophies",
	"cancel": "Cancel",
	"cancel_candidacy": "Cancel request",
	"candidacy_canceled": "Candidacy canceled",
	"candidacy_for_team": "Request for team {team}",
	"challenge": "Challenge",
	"click_to_change_avatar": "Click to change",
	"click_to_change_country": "Click to change",
	"connected": "Connected",
	"contributor": "Contributor",
	"country_ok": "Back",
	"country_selection": "Country selection",
	"create": "Create",
	"create_team": "Create a team",
	"defeats": "losses",
	"deleted": "Farmer deleted",
	"deleted_message": "This farmer deleted his account :(",
	"deleted_name": "Farmer deleted",
	"disconnected": "Disconnected",
	"draws": "draws",
	"error_forbidden_name": "This farmer's name is forbidden.",
	"error_name_already_used": "The name of your farmer is already in use",
	"error_name_length": "Your farmer's name must contain between %d and %d characters",
	"error_name_format": "Your farmer's name must contain only alphanumeric characters",
	"error_rename_delay": "You have to wait a month between two renames from your farmer.",
	"farmer_have_1_warning": "This farmer has 1 warning",
	"farmer_have_n_warnings": "This farmer has {0} warnings",
	"farmer_not_found": "Farmer not found",
	"farmer_not_found_message": "Farmer with id <b>{0}</b> not found :(",
	"forum_messages": "{0} messages",
	"fights": "Fights",
	"garden": "Garden",
	"garden_no": "NO",
	"garden_yes": "YES",
	"given_by_x_the_d": "Given by <a href='/farmer/%1$s'>%2$s</a> the %3$s",
	"godfather_link": "Referral link",
	"godfather_link_description": "Send this link to people you want to refer",
	"godfather_link_ok": "Agree",
	"godfather_of": "{farmers}'s referrer",
	"godson_of": "{farmer}'s referred",
	"history": "History",
	"invalid_name": "Invalid name",
	"last_connection": "Last connection {0}",
	"leek_level_n": "Level {0}",
	"leeks": "Leeks",
	"logout": "Logout",
	"moderator": "Moderator",
	"never_connected": "Never connected",
	"name_already_used": "This team name is already used",
	"no_country": "no country",
	"no_team": "No team",
	"no_trophies_yet": "No trophies yet",
	"not_registered": "You are not registered for a tournament",
	"ratio": "Ratio",
	"registered": "Registered ",
	"registered_the": "Registered on {0}",
	"register_to_tournament": "Register for tournaments",
	"rename": "Rename",
	"rename_description": "This operation will allow you to rename your farmer, you can pay with Habs or crystals. It is possible to do it only once a month",
	"rename_done": "Renamed farmer!",
	"rename_info": "The new name does NOT replace the login name, but only your name displayed in the game",
	"rename_new_name": "New display name",
	"rename_not_enough_crystals": "You don't have enough crystals",
	"rename_not_enough_habs": "You don't have enough habs.",
	"rename_pay_crystals": "Pay in crystals",
	"rename_pay_habs": "Pay in habs",
	"report": "Report",
	"see_all_trophies": "See all",
	"see_tournament": "See the tournament",
	"send_private_message": "Message",
	"talent": "Farmer Talent",
	"team_created": "Team created",
	"team_name": "Name",
	"tournament_of": "Tournament of {0}",
	"tournaments": "Tournaments",
	"tournament_time": "Farmer tournament every day from 6PM to 8PM (French timezone)",
	"trophies": "Trophies",
	"trophy_obtained": "Obtained {0}",
	"n_trophies": "{0} trophies",
	"no_icon": "none",
	"unregister": "Unregister",
	"impossible_to_unregister_moderator": "Impossible to delete a moderator.",
	"impossible_to_unregister_team": "You are the owner of a team, you shall first dissolve before deleting your account.",
	"unregister_wrong_password": "The password is incorrect",
	"upload_failed": "An error occurred: {0}",
	"uploading_avatar": "Uploading avatar...",
	"upload_success": "Upload succeed!",
	"validate": "Validate",
	"victories": "victories",
	"warnings": "Warnings",
	"wins": "wins",
	"you_must_have_2_leeks": "You need at least 2 leeks to register for the farmer tournament",
	"you_have_n_warnings": "You have {0} warnings",
	"verified": "Verified",
	"not_verified": "Not verified",
	"display_farmer": "farmer",
	"display_team": "team",
	"trophy_x": "Trophy {0}",
	"sponsorship": "Sponsorship",
	"godsons_level": "Recursive total level of referrals"
}

	Farmer.options.i18n = { messages: {en: messages }}
	export default Farmer